import { useTranslation as e } from "../../i18n.mjs";
import { ToolbarButton as t } from "../../components/content-controls/toolbar-button.mjs";
import { UrlInput as n } from "../../components/url-input.mjs";
import { useEffect as r, useState as i } from "react";
import { Fragment as a, jsx as o, jsxs as s } from "react/jsx-runtime";
import { CheckIcon as c, Download01Icon as l, Edit01Icon as u, LinkBroken01Icon as d } from "@systemeio/icons";
//#region src/extensions/link-extension/link-bubble-state.tsx
function f({ href: n, unsetLink: r, setIsEditing: i }) {
	let { t: c } = e();
	return /* @__PURE__ */ s(a, { children: [/* @__PURE__ */ o("div", {
		className: "w-[220px] truncate",
		children: /* @__PURE__ */ o("a", {
			className: "text-text-link truncate px-3 underline",
			href: n,
			rel: "noopener noreferrer",
			target: "_blank",
			children: n
		})
	}), /* @__PURE__ */ s("div", {
		className: "flex",
		children: [/* @__PURE__ */ o(t, {
			label: c("unset"),
			onClick: r,
			children: /* @__PURE__ */ o(d, {})
		}), /* @__PURE__ */ o(t, {
			label: c("link"),
			onClick: () => i(!0),
			children: /* @__PURE__ */ o(u, {})
		})]
	})] });
}
function p({ initialValue: u, onSaveLink: d, openFileSelector: f, schemeOptions: p }) {
	let { t: m } = e(), [h, g] = i(u);
	r(() => {
		g(u);
	}, [u]);
	let _ = h.length === 0;
	return /* @__PURE__ */ s(a, { children: [/* @__PURE__ */ o(n, {
		schemeOptions: p,
		className: "w-[250px]",
		value: h,
		onChange: g
	}), /* @__PURE__ */ s("div", {
		className: "flex",
		children: [/* @__PURE__ */ o(t, {
			label: m("image"),
			onClick: f,
			children: /* @__PURE__ */ o(l, {})
		}), /* @__PURE__ */ o(t, {
			disabled: _,
			label: m("global.apply"),
			onClick: () => d(h),
			type: "submit",
			children: /* @__PURE__ */ o(c, {})
		})]
	})] });
}
//#endregion
export { p as LinkBubbleEdit, f as LinkBubbleView };
